<div class="bolide-loader-container d-flex align-items-center justify-content-center">
    <section class="dbe-loader-stage text-center" aria-label="Department of Basic Education dashboard loading">
        <div class="dbe-loader-emblem mx-auto mb-4" aria-hidden="true">
            <span class="dbe-loader-ring dbe-loader-ring-one"></span>
            <span class="dbe-loader-ring dbe-loader-ring-two"></span>
            <span class="dbe-loader-ring dbe-loader-ring-three"></span>
            <span class="dbe-loader-logo-mark"></span>
        </div>

        <p class="dbe-loader-kicker mb-2">Department of Basic Education</p>
        <h1 class="dbe-loader-title mb-3">Preparing your dashboard</h1>

        <div class="dbe-loader-status d-inline-flex align-items-center gap-2 rounded-pill mb-4">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span>Loading secure insights</span>
        </div>

        <div class="dbe-loader-track mx-auto" aria-hidden="true">
            <span></span>
        </div>
    </section>
</div>
